import axios from 'axios';
import { useEffect, useState } from 'react';
import { Link, useHistory } from 'react-router-dom';
import { Task } from '../types/task';
import { StorageKeys, StorageUtility } from '../StorageUtility';
import { ArrowRight } from 'lucide-react';
import { CircularProgress } from '@mui/material';

const DashboardPage = () => {
  const [tasks, setTasks] = useState<Task[]>([]);
  const [loading, setLoading] = useState<boolean>(true);
  const navigator = useHistory();

  const handleCreateTask = () => {
    navigator.push('/define-task');
  };

  useEffect(() => {
    const abortController = new AbortController();
    const sessionToken = StorageUtility.getItem(StorageKeys.SESSION_TOKEN);
    if (sessionToken != null && sessionToken != undefined) {
      setTimeout(() => {
        getTasks();
      }, 100);
    } else {
      navigator.replace('/login');
    }
    return () => abortController.abort();
  }, []);

  const getTasks = async () => {
    try {
      setLoading(true);
      const response = await axios.get('/los/v3/api-playground/task');
      const data: Task[] = response.data as Task[];
      setTasks(data);
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error: any) {
      if (
        error.response?.status === 401 ||
        error.response?.status === 403 ||
        error.response?.data?.errorCode === 'VGP_TOKEN_1000'
      ) {
        StorageUtility.clear();
        navigator.replace('/login');
      } else {
        console.error('API Error:', error);
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="p-10 min-w-1/2">
      <div className="mb-10 flex flex-col md:flex-row items-start md:items-center justify-between w-full sm:w-3/4 gap-4">
        <label className="font-bold text-5xl">Dashboard</label>
        <button
          style={{ display: 'none' }}
          className="bg-primary-dark hover:bg-primary text-white font-semibold py-2 px-4 rounded shadow inline-flex items-center gap-2"
          onClick={handleCreateTask}>
          Define New Task
          <ArrowRight className="w-4 h-4" />
        </button>
      </div>

      {/* Loading Spinner */}
      {loading && (
        <div className="mt-20 flex flex-col md:flex-row items-start md:items-center justify-center w-full sm:w-3/4 gap-4">
          <CircularProgress />
        </div>
      )}

      {/* Empty State */}
      {!loading && tasks.length === 0 && (
        <div className="mt-10 flex flex-col md:flex-row items-start md:items-center justify-center w-full sm:w-3/4 gap-4">
          <label className="font-bold text-xl text-gray-500">No tasks found</label>
        </div>
      )}

      {/* Task List */}
      {!loading && tasks.length > 0 && (
        <div>
          {tasks.map((item) => (
            <Link
              to={{
                pathname: '/task-detail',
                state: {
                  task: item
                },
                search: 'id=' + item.id
              }}
              key={item.id}>
              <div className="p-2 mb-2 border border-primary-light rounded-md w-3/4 hover:bg-primary-dark hover:text-white hover:border-white flex flex-col">
                <label className="font-semibold text-xl">{item.name}</label>
              </div>
            </Link>
          ))}
        </div>
      )}
    </div>
  );
};

export default DashboardPage;
